declare var ko: any;

// Keep operator handling shared by the reports without changing the vendor controls.
export class dynamicFilterOperators {

    public static readonly html = `
        <button type="button" class="dynamic-filter-operator" role="switch" data-bind="
            click: filter.getTemplateViewModel().toggleFilterOperator,
            css: {
                'is-excluding': filter.getTemplateViewModel().filterOperator() === 'exclude'
            },
            attr: {
                'aria-checked': filter.getTemplateViewModel().filterOperator() === 'exclude' ? 'true' : 'false',
                'aria-label': 'Exclude ' + filter.getTemplateViewModel().label()
            }">
            <span class="dynamic-filter-switch" aria-hidden="true"></span>
            <span>Exclude</span>
        </button>`;

    public static initialize(dynamicFilters: any[], caller: any): void {

        dynamicFilters.forEach(dynamicFilter => {

            const filter = dynamicFilter.filter;
            const model = filter.getTemplateViewModel();

            model.filterOperator = ko.observable('include');
            model.onFilterOperatorChange = () => {

                const hasItems = dynamicFilter.type !== 'searchField' && model.selectedItems().length > 0;
                const keyword = dynamicFilter.type === 'searchField'
                    ? model.filterKeyword()
                    : filter.getContainSearchFilterKeyword();

                // Remember the mode for the next selection without reloading an unchanged report.
                if (hasItems || keyword) {

                    caller.filterMultipleSelectorOnChange();
                }
            };

            model.toggleFilterOperator = () => {

                model.filterOperator(model.filterOperator() === 'exclude' ? 'include' : 'exclude');
                model.onFilterOperatorChange();
            };

            // Updating tags while restoring a URL must not trigger another report request.
            model.filterOperator.subscribe(() => {

                if (dynamicFilter.type === 'searchField') {

                    return;
                }

                filter.setTagContainerCaption('Selected ' + dynamicFilter.name + ':');
                const items = dynamicFilter.type === 'multiSelect' ? filter.getItems() : model.selectedItems();
                const ids = dynamicFilter.type === 'multiSelect' ? model.selectedItems() : items.map(item => item.id);

                filter.setTags(ids, items);
            });
        });
    }

    public static forRequest(selectedFilters: any[], dynamicFilters: any[]): any[] {

        // Include stays implicit so existing URLs and presets keep their original meaning.
        this.eachSelection(selectedFilters, selection => {

            const dynamicFilter = dynamicFilters.find(item => item.filterId === selection.id);

            if (dynamicFilter && dynamicFilter.filter.getTemplateViewModel().filterOperator() === 'exclude') {

                selection.operator = 'exclude';
            }
        });

        return selectedFilters;
    }

    public static restore(dynamicFilters: any[], selectedFilters: any[]): void {

        dynamicFilters.forEach(item => item.filter.getTemplateViewModel().filterOperator('include'));
        this.eachSelection(selectedFilters, selection => {

            const dynamicFilter = dynamicFilters.find(item => item.filterId === selection.id);

            if (!dynamicFilter) {

                return;
            }

            // A saved 404 exclusion must also work before 404 appears in the lookup list.
            if (dynamicFilter.name === 'httpStatus' && dynamicFilter.type === 'multiSelect') {

                const items = dynamicFilter.filter.getItems().slice();
                selection.items = (selection.items || []).map(item => {

                    const existing = items.find(option => option.name === item.name);

                    if (existing) {

                        return existing;
                    }

                    items.push(item);
                    return item;
                });

                dynamicFilter.filter.setItems(items);
            }

            dynamicFilter.filter.getTemplateViewModel().filterOperator(selection.operator === 'exclude' ? 'exclude' : 'include');
        });
    }

    public static setDefaultHttpStatus(dynamicFilters: any[]): void {

        // Any existing report URL (including a saved preset) keeps its original filters.
        // Report URLs retain their dates/settings after an exclusion is removed.
        if (window.location.search.length !== 0) {

            return;
        }

        const dynamicFilter = dynamicFilters.find(item => item.category === 'Custom Dimensions' && item.name === 'httpStatus');

        if (!dynamicFilter) {

            return;
        }

        const filter = dynamicFilter.filter;
        const model = filter.getTemplateViewModel();

        model.filterOperator('exclude');

        if (dynamicFilter.type === 'multiSelect') {

            const items = filter.getItems().slice();
            let status = items.find(item => item.name === '404');

            if (!status) {

                status = {id: 'httpStatus-default-404', name: '404'};
                items.push(status);
                filter.setItems(items);
            }

            filter.setSelectedItems([status]);
            filter.setTags([status.id], items);
        } else if (dynamicFilter.type === 'autoCompleteMultiSelect') {

            const status = {id: 'httpStatus-default-404', name: '404'};
            model.selectedItems([status]);
            model.selectedItemIds([status.id]);
            model.selectedItemNames([status.name]);
            filter.setTags([status.id], [status]);
        }
    }

    private static eachSelection(selectedFilters: any[], callback: (selection: any) => void): void {

        selectedFilters.forEach(group => Object.values(group).forEach(category => {

            if (category && typeof category === 'object') {

                Object.values(category).forEach(callback);
            }
        }));
    }
}



// WEBPACK FOOTER //
// ./js/components/dynamicFilterOperators.ts